module.exports = __webpack_public_path__ + "img/article-image-2.966c3b0c.webp";